import { BrowserRouter as Router } from 'react-router-dom';
import Header from 'components/organisms/Header';
import Routes from 'routes';
import Loading from 'components/atoms/Loading';
import ResponseMsg from 'components/atoms/ReponseMsg';
import { useContext, useEffect } from 'react';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import auth from 'services/auth';
import api from 'services/api';
import normalizeTags from 'components/helpers/normalizeTags';

const App = () => {
  const { setUser, loading, setLoading, setTags, setResponseMsg } = useContext(GlobalContext);

  useEffect(() => {
    api
      .getTags()
      .then((response) => {
        setTags(normalizeTags(response.data.Item));
      })
      .catch((error) => {
        console.error(error);
        setResponseMsg({ isVisible: true, error: true, msg: error.message });
      })
      .finally(() => setLoading(false));
  }, [setLoading, setResponseMsg, setTags]);

  useEffect(() => {
    auth
      .login()
      .then((response) => {
        const { error, user } = response;
        if (!error && user?.token) {
          setUser({ isAuthenticated: true, ...user });
        }
      })
      .catch((error) => {
        console.error(error);
        setResponseMsg({ isVisible: true, error: true, msg: error.message });
      });
  }, [setUser, setResponseMsg]);

  return (
    <>
      <div className="app">
        <Router>
          <Header />
          <Routes />
        </Router>
      </div>
      {loading && <Loading />}
      <ResponseMsg />
    </>
  );
};

export default App;
